import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'

import styles from 'assets/jss/material-kit-react/components/timelineStyle.js'

const useStyles = makeStyles(styles)

export default function Timeline(props) {
  const classes = useStyles()
  const { items, color } = props

  return (
    <div className={classes.timeline}>
      {items.map((item, index) => (
        <div key={index} className={classes.timelineItem}>
          <div className={classes.timelinePanel}>
            <div className={classNames(classes.timelineBadge, classes[color])}>
              <div className={classes.timelineDate}>{item.date}</div>
            </div>
            <div className={classes.timelineBody}>
              <h4 className={classes.timelineTitle}>{item.title}</h4>
              {item.content.map((contentItem, contentIndex) => (
                <div key={contentIndex} className={classes.timelineContentItem}>
                  <p className={classes.timelineDescription} dangerouslySetInnerHTML={{ __html: contentItem.text }} />
                  {contentItem.supplement && <p className={classes.timelineSupplement}>{contentItem.supplement}</p>}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

Timeline.defaultProps = {
  color: 'primary',
}

Timeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string.isRequired,
          supplement: PropTypes.string,
        }),
      ).isRequired,
    }),
  ).isRequired,
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
}
